import { render, staticRenderFns } from "./MomentsSentLeaderboard.vue?vue&type=template&id=342d70dc&"
import script from "./MomentsSentLeaderboard.vue?vue&type=script&lang=js&"
export * from "./MomentsSentLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports